import { application } from "./application"

import ExhibitionToggleController from "./exhibition_toggle_controller"
import HeaderScrollController from "./header_scroll_controller"
import MarqueeController from "./marquee_controller"
import MobileMenuController from "./mobile_menu_controller"
import ModalController   from "./modal_controller"
import SliderController  from "./slider_controller"

application.register("exhibition-toggle", ExhibitionToggleController)
application.register("header-scroll", HeaderScrollController)
application.register("marquee", MarqueeController)
application.register("mobile-menu", MobileMenuController)
application.register("modal",  ModalController)
application.register("slider", SliderController)
